import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border rounded p-3 mb-3 h-300" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "text-primary fw-normal" }, "Current Segmentation:", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-secondary d-flex justify-content-end cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#createSegmentationModal",
  "data-bs-create-edit": "create"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary text-light rounded-pill"
}, [
  /*#__PURE__*/_createTextVNode(" Add New Segmentation "),
  /*#__PURE__*/_createElementVNode("div", { class: "d-inline" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "px-1 ms-2" }, [
      /*#__PURE__*/_createElementVNode("i", {
        class: "fa fa-plus fw-light",
        "aria-hidden": "true"
      })
    ])
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-block text-end text-info"
}
const _hoisted_7 = { class: "table-responsive overflow-auto h-75 mt-3" }
const _hoisted_8 = { class: "table text-secondary" }
const _hoisted_9 = { class: "ps-0" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = ["data-bs-segmentation"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-o",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

import { segmentationObject } from "@/interfaces";
import { PropType } from "vue";


const __default__ = {
  name: "CurrentSegmentations",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  segmentations: {
    type: Array as PropType<Array<segmentationObject>>,
    required: true,
  },
  allowedSegmentations: {
    type: Number,
    default: 0,
  },
},
  emits: ["delete-segmentation"],
  setup(__props, { emit }) {





const deleteSegmentation = (segmentation: segmentationObject) => {
  emit("delete-segmentation", segmentation);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.allowedSegmentations > __props.segmentations.length - 2)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
      : (_openBlock(), _createElementBlock("small", _hoisted_6, "you can add only " + _toDisplayString(__props.allowedSegmentations) + " segmentations! ", 1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.segmentations, (segmentation, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_9, _toDisplayString(segmentation.label), 1),
              _createElementVNode("td", _hoisted_10, [
                (i !== 0 && i !== 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#createSegmentationModal",
                      "data-bs-create-edit": "edit",
                      "data-bs-segmentation": JSON.stringify(segmentation),
                      class: "btn btn-info text-light rounded-pill text-secondary m-1"
                    }, _hoisted_13, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                (i !== 0 && i !== 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: ($event: any) => (deleteSegmentation(segmentation)),
                      class: "btn btn-primary text-light rounded-pill m-1"
                    }, _hoisted_16, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})